import { SensorTypeModel } from 'src/app/core/sensor-type.model';

export interface SensorState {
  sensorTypes: SensorTypeModel[];
}

export const initialSensorState: SensorState = {
  sensorTypes: [],
};
